import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCity,
  setItemCode, setItemCountry,
  setItemName,
  setItemNameLat, setItemRegion,
} from '@/modules/Dictionary/__form/item';
import FInput from '@/plugins/form/FInput';
import FTime from '@/plugins/form/FTime';

export default class DictionaryTransferForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'transfert';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)();
    setItemNameLat.bind(this)();
    setItemCode.bind(this)();
    setItemCountry.bind(this)();
    setItemRegion.bind(this)();
    setItemCity.bind(this)();
    this.setItemDuration();
    this.setItemPlaceFrom();
    this.setItemPlaceTo();
    this.setItemTimeFrom();
    this.setItemTimeTo();
  }

  setItemDuration() {
    this.duration = new FInput({
      name: 'Duration',
      label: 'Продолжительность',
    });
    this.duration.setValidatorMax(10);
    this.setItem('duration', this.duration);
  }

  setItemPlaceFrom() {
    this.placeFrom = new FInput({
      name: 'PlaceFrom',
      label: 'Место отправления',
    });
    this.placeFrom.setValidatorMax(50);
    this.setItem('placeFrom', this.placeFrom);
  }

  setItemPlaceTo() {
    this.placeTo = new FInput({
      name: 'PlaceTo',
      label: 'Место прибытия',
    });
    this.placeTo.setValidatorMax(50);
    this.setItem('placeTo', this.placeTo);
  }

  setItemTimeFrom() {
    this.timeFrom = new FTime({
      name: 'TimeBegin',
      label: 'Время отправления',
    });
    this.setItem('timeFrom', this.timeFrom);
  }

  setItemTimeTo() {
    this.timeTo = new FTime({
      name: 'TimeEnd',
      label: 'Время прибытия',
    });
    this.setItem('timeTo', this.timeTo);
  }
}
